/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_nA_110_65 as Componente_nA_110_65,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorMultiple as SelectorMultiple,
  rec_cA as cA,
  rec_lA as lA,
  rec_uA as uA,
} from "../../runtime/index.jsx";
export function TipografiaMarca(e) {
  let t = (0, ReactCompiler.c)(43),
    { f: n, setF: r, fuentes: i } = e,
    a = uA,
    o;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (
        <span
          className={`text-xs text-(--text)`}
          children={`Texto de la aplicación`}
        />
      )),
      (t[0] = o))
    : (o = t[0]);
  let s = n.fuenteCuerpo,
    c;
  t[1] !== n || t[2] !== r
    ? ((c = (e) =>
        r({
          ...n,
          fuenteCuerpo: e,
        })),
      (t[1] = n),
      (t[2] = r),
      (t[3] = c))
    : (c = t[3]);
  let l;
  t[4] === i.cuerpo
    ? (l = t[5])
    : ((l = i.cuerpo ?? []), (t[4] = i.cuerpo), (t[5] = l));
  let u;
  t[6] === l ? (u = t[7]) : ((u = l.map(lA)), (t[6] = l), (t[7] = u));
  let d;
  t[8] !== n.fuenteCuerpo || t[9] !== c || t[10] !== u
    ? ((d = <SelectorMultiple value={s} onChange={c} opciones={u} />),
      (t[8] = n.fuenteCuerpo),
      (t[9] = c),
      (t[10] = u),
      (t[11] = d))
    : (d = t[11]);
  let f;
  t[12] !== n.fuenteCuerpo || t[13] !== i.cuerpo
    ? ((f = a(i.cuerpo, n.fuenteCuerpo)),
      (t[12] = n.fuenteCuerpo),
      (t[13] = i.cuerpo),
      (t[14] = f))
    : (f = t[14]);
  let p;
  t[15] === f
    ? (p = t[16])
    : ((p = <span className={`text-xs text-(--text)`} children={f} />),
      (t[15] = f),
      (t[16] = p));
  let m;
  t[17] !== d || t[18] !== p
    ? ((m = <label className={`flex flex-col gap-1`} children={[o, d, p]} />),
      (t[17] = d),
      (t[18] = p),
      (t[19] = m))
    : (m = t[19]);
  let h;
  t[20] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((h = (
        <span className={`text-xs text-(--text)`} children={`Títulos cortos`} />
      )),
      (t[20] = h))
    : (h = t[20]);
  let _ = n.fuenteTitulos,
    v;
  t[21] !== n || t[22] !== r
    ? ((v = (e) =>
        r({
          ...n,
          fuenteTitulos: e,
        })),
      (t[21] = n),
      (t[22] = r),
      (t[23] = v))
    : (v = t[23]);
  let y;
  t[24] === i.titulos
    ? (y = t[25])
    : ((y = i.titulos ?? []), (t[24] = i.titulos), (t[25] = y));
  let b;
  t[26] === y ? (b = t[27]) : ((b = y.map(cA)), (t[26] = y), (t[27] = b));
  let x;
  t[28] !== n.fuenteTitulos || t[29] !== v || t[30] !== b
    ? ((x = <SelectorMultiple value={_} onChange={v} opciones={b} />),
      (t[28] = n.fuenteTitulos),
      (t[29] = v),
      (t[30] = b),
      (t[31] = x))
    : (x = t[31]);
  let S;
  t[32] !== n.fuenteTitulos || t[33] !== i.titulos
    ? ((S = a(i.titulos, n.fuenteTitulos)),
      (t[32] = n.fuenteTitulos),
      (t[33] = i.titulos),
      (t[34] = S))
    : (S = t[34]);
  let C;
  t[35] === S
    ? (C = t[36])
    : ((C = <span className={`text-xs text-(--text)`} children={S} />),
      (t[35] = S),
      (t[36] = C));
  let w;
  t[37] !== x || t[38] !== C
    ? ((w = <label className={`flex flex-col gap-1`} children={[h, x, C]} />),
      (t[37] = x),
      (t[38] = C),
      (t[39] = w))
    : (w = t[39]);
  let T;
  return (
    t[40] !== w || t[41] !== m
      ? ((T = (
          <Componente_nA_110_65
            titulo={`Tipografía`}
            ayuda={`Todas son de uso libre.`}
            children={[m, w]}
          />
        )),
        (t[40] = w),
        (t[41] = m),
        (t[42] = T))
      : (T = t[42]),
    T
  );
}
